module.exports = __webpack_public_path__ + "static/media/check_small.2202cd2e.svg";